<template>
  <div class="active-coverage-compact">
    <button
      v-if="assignedCount > 0"
      type="button"
      class="coverage-btn"
      :class="{ 'coverage-btn--live': activeCount > 0, 'coverage-btn--empty': activeCount === 0 }"
      :aria-label="buttonLabel"
      @click.stop="showModal = true"
    >
      <span class="coverage-dot" aria-hidden="true"></span>
      <span class="coverage-ratio">{{ activeCount }}/{{ assignedCount }}</span>
    </button>
    <span v-else class="coverage-na">—</span>

    <WorkingAreaQuickView
      v-if="showModal"
      title-key="active_supervisors_column"
      :subtitle="areaName"
      hint-key="active_supervisors_coverage_hint"
      :summary="activeCount > 0 ? `${activeCount} / ${assignedCount}` : ''"
      :items="supervisorNames"
      :empty-text="$t('no_active_supervisors')"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import WorkingAreaQuickView from './WorkingAreaQuickView.vue'

export default {
  props: {
    areaName: {
      type: String,
      default: '',
    },
    activeSupervisors: {
      type: Array,
      default: () => [],
    },
    activeCount: {
      type: Number,
      default: 0,
    },
    assignedCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    supervisors() {
      return Array.isArray(this.activeSupervisors) ? this.activeSupervisors : []
    },
    supervisorNames() {
      return this.supervisors.map((s) => s.name)
    },
    buttonLabel() {
      const names = this.supervisorNames.join(', ')
      const countLabel = `${this.activeCount}/${this.assignedCount} ${this.$t('supervisors_active_label')}`
      return names ? `${countLabel}: ${names}` : countLabel
    },
  },
  components: { WorkingAreaQuickView },
}
</script>

<style lang="scss" scoped>
.active-coverage-compact {
  flex-shrink: 0;
}

.coverage-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid #d5dae1;
  background: #f6f7f9;
  color: #5c6570;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: #b8c4d4;
    background: #eef2f7;
  }

  &--live {
    border-color: #b8dfc8;
    background: #edf8f1;
    color: #1f6b3f;

    .coverage-dot {
      background: #2ecc71;
    }
  }

  &--empty .coverage-dot {
    background: #b0b8c1;
  }
}

.coverage-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.coverage-na {
  color: #b0b8c1;
  font-size: 13px;
}
</style>
